var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterUnset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.388 12.0184C12.1738 12.1924 11.8592 12.16 11.685 11.946L3.87363 2.35207C3.69915 2.13777 3.7316 1.82258 3.94607 1.64832C4.16023 1.47431 4.47488 1.5067 4.6491 1.72068L12.4604 11.3146C12.6349 11.5289 12.6025 11.8441 12.388 12.0184Z",
    fill: "#242426"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9875 7.93511L13.9053 4.54346C14.3701 4.00321 13.9863 3.16666 13.2736 3.16666H7.10506L7.91926 4.16666H12.9104L10.3461 7.14733L10.9875 7.93511ZM10.325 8.70522L9.68358 7.91744L9.11344 8.58017C8.98337 8.73136 8.91184 8.9242 8.91184 9.12364V12.4081L7.08831 13.6998V9.12364C7.08831 8.92419 7.01678 8.73136 6.8867 8.58017L3.08978 4.16666H6.62972L5.81553 3.16666H2.72655C2.01387 3.16666 1.63004 4.00321 2.09482 4.54346L6.08831 9.18547V14.0221C6.08831 14.6984 6.85144 15.093 7.40332 14.7021L9.56018 13.1743C9.78075 13.0181 9.91184 12.7646 9.91184 12.4943V9.18547L10.325 8.70522Z",
    fill: "#242426"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterUnset);
export default __webpack_public_path__ + "static/media/FilterUnset.1f4184505203ccb6741e0b219c3199e1.svg";
export { ForwardRef as ReactComponent };